/**
 * Convert a timezone-naive `<input type="datetime-local">` value
 * (e.g. "2026-06-18T14:00") into an absolute ISO-8601 string with offset.
 *
 * BUG-1 / APT-TZ-01 (audit 2026-06-16): the booking flow sent the naive string
 * as-is, and the backend (Time.zone = UTC) stored "14:00" as 14:00 UTC, so a BRT
 * user who picked 14:00 saw 11:00. Drag-reschedule already sent an absolute
 * timestamp via Date#toISOString(); this makes creation consistent. `new Date()`
 * interprets the naive value as the browser's local time (same context the agenda
 * renders it back in), so the displayed hour now round-trips to the picked hour.
 *
 * Returns the input unchanged when it is empty or already carries a timezone
 * marker (offset or trailing Z) so callers can pass it through idempotently.
 */
export function localDateTimeToISO(value) {
  if (!value || typeof value !== 'string') return value;
  // Already absolute (has Z or a ±HH:MM offset after the time) — leave as is.
  if (/(Z|[+-]\d{2}:?\d{2})$/.test(value)) return value;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toISOString();
}

export default { localDateTimeToISO };
